import { render, staticRenderFns } from "./OperaHotCityWindow.vue?vue&type=template&id=2bc3f80e&scoped=true&"
import script from "./OperaHotCityWindow.vue?vue&type=script&lang=js&"
export * from "./OperaHotCityWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaHotCityWindow.vue?vue&type=style&index=0&id=2bc3f80e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc3f80e",
  null
  
)

export default component.exports